import React from 'react';

const IconCheckSmall = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
    <path d="M10.9481 2.20145L4.35221 9.40145L1.34814 6.12226" stroke="#111" strokeWidth="1.5" />
  </svg>
);

export default IconCheckSmall;
